import React from "react";
import { connect } from "react-redux";
import withReduxProvider from "web/react/redux-provider";
import { clearCollection } from "web/redux/ducks/collection-bar";
import CollectionItem from "web/react/components/collection-bar/collection-item/collection-item";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import { gettext } from "web/script/modules/django-i18n";
import analytics from "web/script/analytics/analytics";
import styles from "./collection-bar.css";

interface CollectionState {
    productId: string;
    productImageUrl: string;
}

interface CollectionBarProps {
    productId: string;
    productImageUrl: string;
    collectionOne: CollectionState;
    collectionTwo: CollectionState;
    clearCollection: (payload: string) => void;
    openCustomerCaptureOverlay: (emailObj: object) => void;
}

function mapStateToProps(state): object {
    const { collectionOne, collectionTwo } = state.collectionBarReducer;
    return {
        collectionOne,
        collectionTwo,
    };
}

function mapDispatchToProps(dispatch): object {
    return {
        clearCollection: (payload): void => dispatch(clearCollection(payload)),
        openCustomerCaptureOverlay: (emailObj): void =>
            dispatch(openCustomerCaptureOverlay(emailObj)),
    };
}

export function CollectionBar({
    productId,
    productImageUrl,
    collectionOne,
    collectionTwo,
    clearCollection,
    openCustomerCaptureOverlay,
}: CollectionBarProps): null | JSX.Element {
    function handleClick(): void {
        analytics.event("ta_collection", "ta_collection_cta", "collection_bar");
        openCustomerCaptureOverlay({ captureType: "ta_collection" });
    }

    function handleClearCollection(event: React.MouseEvent, productId: string): void {
        analytics.event("ta_collection", "ta_collection_cb_off", "collection_bar");
        clearCollection(productId);
    }

    return (
        <section className={styles.collectionBar}>
            <ul>
                <li>
                    <img src={productImageUrl} alt={"Your new collection " + productId} />
                </li>
                <li>
                    {collectionOne.productId != "" ? (
                        <CollectionItem
                            productId={collectionOne.productId}
                            productImageUrl={collectionOne.productImageUrl}
                            handleItemClick={handleClearCollection}
                        />
                    ) : null}
                    <SVGIcon name="round-plus" className={styles.icon} />
                </li>
                <li>
                    {collectionTwo.productId != "" ? (
                        <CollectionItem
                            productId={collectionTwo.productId}
                            productImageUrl={collectionTwo.productImageUrl}
                            handleItemClick={handleClearCollection}
                        />
                    ) : null}
                    <SVGIcon name="round-plus" className={styles.icon} />
                </li>
                <li>
                    <button onClick={handleClick}>
                        <SVGIcon name="saved-search-bookmark" className={styles.searchIcon} />
                        {gettext("feed.collection.title")}
                    </button>
                </li>
            </ul>
        </section>
    );
}

export default withReduxProvider(connect(mapStateToProps, mapDispatchToProps)(CollectionBar));
